/// <reference path="./TeamMenu.d.ts" />
/// <reference path="../../types/index.d.ts" />

import React from 'react';
import ScrollMenu from '~/components/ScrollMenu/ScrollMenu';
import ScrollMenuElement from '~/components/ScrollMenuElement/ScrollMenuElement';
import Link from '~/components/Link/Link';
import getOr from '~/util/getOr';

import StyledComponent from '~/components/Styled/Styled';
import css from '~/components/MatchupMenu/MatchupMenu.scss';

/* eslint-disable react/prefer-stateless-function */
class TeamMenu extends React.Component<Props> {
  static displayName: string;
  static defaultProps: Partial<Props> = {
    currentSection: 'news',
  };

  render() {
    const teamRoute = getOr(this.props.team, 'api_uri', null);

    return (
      <ScrollMenu>
        <Link route={teamRoute}>
          <a>
            <ScrollMenuElement name="NEWS" selected={this.props.currentSection === 'news'} />
          </a>
        </Link>
        {this.props.team.has_team_stats && (
          <Link route={teamRoute ? `${teamRoute}/stats` : null}>
            <a>
              <ScrollMenuElement name="STATS" selected={this.props.currentSection === 'stats'} />
            </a>
          </Link>
        )}
        <Link route={teamRoute ? `${teamRoute}/schedule` : null}>
          <a>
            <ScrollMenuElement
              name="SCHEDULE"
              selected={this.props.currentSection === 'schedule'}
            />
          </a>
        </Link>
        <Link route={teamRoute ? `${teamRoute}/roster` : null}>
          <a>
            <ScrollMenuElement name="ROSTER" selected={this.props.currentSection === 'roster'} />
          </a>
        </Link>
        <div className={css.mobileView}>
          <Link route={teamRoute ? `${teamRoute}/info` : null}>
            <a>
              <ScrollMenuElement name="info" selected={this.props.currentSection === 'info'} />
            </a>
          </Link>
        </div>
      </ScrollMenu>
    );
  }
}

TeamMenu.displayName = 'TeamMenu';

export default StyledComponent(TeamMenu, [css]);
